export function checkPhone(str) {
  if (!/^((1[3,5,6,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7,9]))\d{8}$/.test(str)) {
    return false
  }
  return true;
}

export function checkEmail(str) {
  let re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
  if (!re.test(str)) {
    return false;
  } else {
    return true;
  }
}

export function checkPassword(str) {
  let re = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=([\x21-\x7e]+)[^a-zA-Z0-9]).{8,32}$/;
  if (!re.test(str)) {
    return false;
  } else {
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/utils/util_new.js